export default {
  title: "Dashboard",
  subtitle: "Patient portal",

  // OTP entry page (visit resolution)
  entry: {
    errorTitle: "Could not load visit",
    timeoutTitle: "Taking too long",
    timeoutSubtitle: "Your session could not be verified. Please try again.",
    retry: "Try again",
  },

  results: {
    title: "Results",
    subtitle: "Laboratory results",
    comingSoon: "Coming Soon",
    description: "This feature will allow you to view your laboratory results.",

    table: {
      examination: "Examination",
      flag: "Flag",
      result: "Result",
      units: "Units",
      refRange: "Ref. Range",
      takenTooltip: "Sample collection date and time",
    },

    patient: {
      title: "Patient",
      name: "Name",
      dob: "Date of birth",
      sex: "Sex",
      male: "Male",
      female: "Female",
      maleShort: "M",
      femaleShort: "F",
      identifier: "Identifier",
      visit: "Visit",
      date: "Visit date",
      location: "Registration location",
      copyVisit: "Copy visit ID",
      copyPid: "Copy patient identifier",
      copied: "Copied!",
      pid: "PID",
      tooltipVisitId: "Visit ID",
      tooltipVisitDate: "Visit date",
      tooltipCategory: "Visit category",
      tooltipLocation: "Registration location",
      tooltipRequester: "Requester",
      tooltipDoctor: "Attending doctor",
      tooltipNotes: "Notes",
      tooltipSaleSchema: "Sale schema",
      tooltipFund: "Department / Fund",
    },

    sections: {
      results: "Results",
      samples: "Collected samples",
    },

    sample: {
      barcode: "Barcode",
      taken: "Collected",
    },

    refresh: {
      tooltip: "Refresh results",
    },

    pdf: {
      tooltip: "Download PDF",
    },

    email: {
      tooltip: "Send by email",
    },

    flagLegend: {
      title: "Flag reference",
    },

    colorLegend: {
      title: "Colour guide",
    },

    disclaimerTitle: "Medical disclaimer",
    disclaimer:
      "Laboratory results are not a diagnosis, but a basis for it. Taking any medications without a prescription may be dangerous for your health. Please consult qualified doctors for interpretation of the results.",

    error: {
      loadFailed: "Failed to load results. Please try again.",
      noResults: "No results are available for this visit.",
      noResultsTableTitle: "No results available",
      noResultsTableSubtitle: "No examination results have been registered for this visit.",
      noSamplesTableTitle: "No samples recorded",
      noSamplesTableSubtitle: "No sample collection has been registered for this visit.",
      retry: "Try again",
      login: "Log in",
      serverTitle: "Something went wrong",
      serverSubtitle: "Failed to load results. Please try again.",
      networkTitle: "Connection lost",
      networkSubtitle: "Unable to reach the server. Check your connection.",
      timeoutTitle: "Request timed out",
      timeoutSubtitle:
        "The server did not respond within the expected time. This is usually temporary — please try again shortly.",
      authTitle: "Session expired",
      authSubtitle: "Please log in again to continue.",
      unknownTitle: "Unexpected error",
      unknownSubtitle: "Something went wrong. Please try again later.",
    },

    payment: {
      overdueDialogTitle: "Payment pending",
      overdueDialogSubtitle: "Results will be available after payment",
      overdueDialogText:
        "Your laboratory results are ready, but access requires payment of the outstanding balance. Please visit the reception desk or the laboratory cashier.",
      overdueDialogClose: "Close",
      overdueAlert:
        "Access to results requires payment. Please visit the reception desk or the laboratory cashier.",
      overdueTableTitle: "Payment pending",
      overdueTableSubtitle:
        "Your laboratory results are ready, but access requires payment of the outstanding balance. Please visit the reception desk or the laboratory cashier.",
    },
  },

  balance: {
    title: "Balance",
    subtitle: "Payment balance",

    patient: {
      title: "Patient",
      visit: "Visit",
      copyVisit: "Copy visit ID",
    },

    sale: {
      title: "Sales",
      label: "Sale:",
      balance: "Balance",
      copyId: "Copy sale ID",
      noSalesTitle: "No sales on record",
      noSalesSubtitle: "No sales have been registered for this visit.",
    },

    products: {
      title: "Products",
      product: "Product",
      price: "Price",
      totalLiabilities: "Total Liabilities",
      noProductsTitle: "No products on record",
      noProductsSubtitle: "No products have been registered for this sale.",
    },

    payments: {
      title: "Payments",
      date: "Payment Date",
      dateTooltip: "Payment date and time",
      type: "Payment Type",
      amount: "Amount",
      totalPaid: "Total Paid",
      methods: {
        cash: "Cash",
        card: "Credit/Debit Card",
        unknown: "Payment",
      },
      noPaymentsTitle: "No payments recorded",
      noPaymentsSubtitle: "No payments have been registered for this sale.",
    },

    currency: "EUR",

    refresh: {
      tooltip: "Refresh balance",
    },

    error: {
      loadFailed: "Failed to load balance. Please try again.",
      noBalance: "No balance information is available for this visit.",
      retry: "Try again",
      login: "Log in",
      serverTitle: "Something went wrong",
      serverSubtitle: "Failed to load balance. Please try again.",
      networkTitle: "Connection lost",
      networkSubtitle: "Unable to reach the server. Check your connection.",
      timeoutTitle: "Request timed out",
      timeoutSubtitle:
        "The server did not respond within the expected time. This is usually temporary — please try again shortly.",
      authTitle: "Session expired",
      authSubtitle: "Please log in again to continue.",
      unknownTitle: "Unexpected error",
      unknownSubtitle: "Something went wrong. Please try again later.",
    },
  },
};
